<script setup lang="ts">
import merge from 'lodash/merge';

interface FormFillTheGaps
{
    content: {
        value: {
            description: string;
            text: string;
        };
    };
}

interface Props
{
    modelValue: any;
}

const props = defineProps<Props>();
const emit = defineEmits<{
    'update:modelValue': [value: any];
}>();

const defaults: any = {
    description: '',
    text: ''
};

const form = computed((): FormType<FormFillTheGaps> =>
{
    return props.modelValue;
});

onBeforeMount(() =>
{
    form.value.content.value = merge(defaults, form.value.content.value);
    form.value.file = null;
});

watch(() => form.value.content.value, (value: any) =>
{
    triggetModel();
    form.value.$errors.clear('content.value.text');
}, { deep: true });

function triggetModel(): any
{
    emit('update:modelValue', form.value);
}
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first('content.value.description')" :state="form.$errors.state('content.value.description')">
        <RichTextEditor
            :id="seconds('description-' + form.id)"
            v-model="form.content.value.description"
            name="description"
            shortcode
            timeline
        />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Tekst do uzupełnienia]]]')" :invalid-feedback="form.$errors.first('content.value.text')" :state="form.$errors.state('content.value.text')" required>
        <RichTextEditor
            id="fillText"
            v-model="form.content.value.text"
            name="question"
            shortcode
            timeline
        />
        <div class="font-small">
            <div>{{ $t('[[[ Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.]]]') }}</div>
            <div>{{ $t('[[[%$ – znacznik otwierający tag]]]') }}</div>
            <div>{{ $t('[[[$% - znacznik zamykający tag]]]') }}</div>
        </div>
    </IdeoFormGroup>
</template>


<style lang="scss" scope>
.font-small {
    font-size: 12px;
}
</style>
